import { jsx as e } from "../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { fixedForwardRef as r } from "../../../utils/preact/fixedForwardRef.js";
const f = r(({ title: i, ...t }, o) => /* @__PURE__ */ e("svg", { ...t, ref: o, width: "7", height: "10", viewBox: "0 0 6 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  i && /* @__PURE__ */ e("title", { children: i }),
  /* @__PURE__ */ e(
    "path",
    {
      d: "M5.56077 2.00011L2.56077 5.00011L5.56077 8.00011L4.50011 9.06077L0.439453 5.00011L4.50011 0.939453L5.56077 2.00011Z",
      fill: t.disabled ? "#8D95A3" : "#00112C"
    }
  )
] }));
export {
  f as default
};
